import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card d-block" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = { class: "text-lg-right" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_8 = { class: "card d-block" }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "" }, "Smart Contract Name", -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { for: "" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { for: "" }
const _hoisted_19 = { class: "form-group bg-light p-3" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { for: "" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "row" }, null, -1)
const _hoisted_24 = {
  key: 1,
  class: "text-center"
}
const _hoisted_25 = {
  key: 2,
  class: "form-group"
}
const _hoisted_26 = { for: "" }
const _hoisted_27 = { class: "form-group mt-3" }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { class: "row align-items-center mb-2" }
const _hoisted_30 = { class: "col-sm-6" }
const _hoisted_31 = { class: "form-check form-check-inline mb-2" }
const _hoisted_32 = {
  for: "",
  title: "Phase Name"
}
const _hoisted_33 = { class: "col-sm-6" }
const _hoisted_34 = { class: "text-sm-right" }
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_37 = { class: "row my-1" }
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_41 = { class: "desc-wrap" }
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_44 = { class: "desc-wrap" }
const _hoisted_45 = /*#__PURE__*/_createVNode("p", { class: "to-upper" }, "No. of days for this phase", -1)
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_48 = { class: "desc-wrap" }
const _hoisted_49 = /*#__PURE__*/_createVNode("p", null, "Phase Timeline", -1)
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createVNode("strong", null, "TBD", -1)
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = /*#__PURE__*/_createVNode("strong", null, "-", -1)
const _hoisted_55 = { class: "mt-4" }
const _hoisted_56 = {
  key: 0,
  class: "border rounded bg-light p-3 mt-2 pb-0"
}
const _hoisted_57 = { class: "row align-items-center mb-2" }
const _hoisted_58 = { class: "col-sm-6" }
const _hoisted_59 = { class: "form-check form-check-inline mb-2" }
const _hoisted_60 = {
  for: "",
  title: "Phase Name"
}
const _hoisted_61 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_62 = { class: "members-list pt-sm-0 text-sm-right" }
const _hoisted_63 = { class: "row my-1" }
const _hoisted_64 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_65 = { class: "iconed-holder d-flex mt-2 align-items-center" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_67 = { class: "desc-wrap" }
const _hoisted_68 = { class: "row mt-2 align-items-start" }
const _hoisted_69 = { class: "col-md-5" }
const _hoisted_70 = { class: "col-md-4" }
const _hoisted_71 = { class: "iconed-holder d-flex align-items-center" }
const _hoisted_72 = { class: "desc-wrap" }
const _hoisted_73 = /*#__PURE__*/_createVNode("p", { class: "to-upper" }, [
  /*#__PURE__*/_createVNode("strong", null, "No. of days for this task:")
], -1)
const _hoisted_74 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_75 = { class: "form-check mt-2" }
const _hoisted_76 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "excludeWeekends"
}, " Exclude Weekends ", -1)
const _hoisted_77 = { class: "mt-2" }
const _hoisted_78 = {
  key: 0,
  class: "list-accordion mt-2"
}
const _hoisted_79 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_80 = { class: "mb-0" }
const _hoisted_81 = { class: "card-body p-2" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "col-md-6" }
const _hoisted_84 = { class: "to-upper" }
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_87 = {
  key: 2,
  class: "border rounded bg-light p-3 mt-2 pb-0"
}
const _hoisted_88 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_89 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_90 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_91 = { class: "sr-only" }
const _hoisted_92 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_93 = { class: "imaged-col" }
const _hoisted_94 = { class: "small-img-wrap" }
const _hoisted_95 = { class: "size" }
const _hoisted_96 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_97 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_98 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_99 = { class: "sr-only" }
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_101 = { class: "imaged-col" }
const _hoisted_102 = { class: "small-img-wrap" }
const _hoisted_103 = { class: "size" }
const _hoisted_104 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_105 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_106 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_107 = { class: "sr-only" }
const _hoisted_108 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_109 = { class: "imaged-col" }
const _hoisted_110 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_111 = { class: "size" }
const _hoisted_112 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_113 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_114 = { class: "centered-wrap" }
const _hoisted_115 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_116 = { class: "sr-only" }
const _hoisted_117 = { class: "size" }
const _hoisted_118 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_119 = {
  key: 4,
  class: "row"
}
const _hoisted_120 = { class: "col-md-4 px-2" }
const _hoisted_121 = { class: "form-group" }
const _hoisted_122 = { class: "col-md-3 px-2" }
const _hoisted_123 = { class: "form-group" }
const _hoisted_124 = /*#__PURE__*/_createVNode("label", { for: "projectDate" }, "Project Timeline", -1)
const _hoisted_125 = /*#__PURE__*/_createVNode("option", { value: "4" }, "To Be Decided Later", -1)
const _hoisted_126 = { value: "5" }
const _hoisted_127 = {
  key: 5,
  class: "my-3"
}
const _hoisted_128 = { key: 6 }
const _hoisted_129 = {
  key: 7,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_130 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_131 = {
  key: 0,
  class: "company-logo-wrap border p-1 rounded my-3 bg-white"
}
const _hoisted_132 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_133 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_134 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_135 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_136 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_137 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_138 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_139 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_140 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_141 = { class: "inline-items mt-3" }
const _hoisted_142 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_143 = { for: "" }
const _hoisted_144 = /*#__PURE__*/_createVNode("span", { class: "required" }, "*", -1)
const _hoisted_145 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_146 = { class: "form-group" }
const _hoisted_147 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_148 = { class: "form-group" }
const _hoisted_149 = { class: "inline-items" }
const _hoisted_150 = { class: "upload-btn-wrapper" }
const _hoisted_151 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_152 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_153 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_154 = { key: 0 }
const _hoisted_155 = { class: "upload-btn-wrapper" }
const _hoisted_156 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_157 = { class: "form-group" }
const _hoisted_158 = { for: "" }
const _hoisted_159 = {
  key: 0,
  class: "image-in-chat preview-image-list"
}
const _hoisted_160 = { class: "row mx-n2" }
const _hoisted_161 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_162 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_163 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_164 = { class: "sr-only" }
const _hoisted_165 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_166 = { class: "imaged-col" }
const _hoisted_167 = { class: "small-img-wrap" }
const _hoisted_168 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_169 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_170 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_171 = { class: "sr-only" }
const _hoisted_172 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_173 = { class: "imaged-col" }
const _hoisted_174 = { class: "small-img-wrap" }
const _hoisted_175 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_176 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_177 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_178 = { class: "sr-only" }
const _hoisted_179 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_180 = { class: "imaged-col" }
const _hoisted_181 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_182 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_183 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_184 = { class: "centered-wrap" }
const _hoisted_185 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_186 = { class: "sr-only" }
const _hoisted_187 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_188 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_189 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_190 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_191 = { class: "sr-only" }
const _hoisted_192 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_193 = { class: "imaged-col" }
const _hoisted_194 = { class: "small-img-wrap" }
const _hoisted_195 = { class: "size" }
const _hoisted_196 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_197 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_198 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_199 = { class: "sr-only" }
const _hoisted_200 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_201 = { class: "imaged-col" }
const _hoisted_202 = { class: "small-img-wrap" }
const _hoisted_203 = { class: "size" }
const _hoisted_204 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_205 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_206 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_207 = { class: "sr-only" }
const _hoisted_208 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_209 = { class: "imaged-col" }
const _hoisted_210 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_211 = { class: "size" }
const _hoisted_212 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_213 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_214 = { class: "centered-wrap" }
const _hoisted_215 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_216 = { class: "sr-only" }
const _hoisted_217 = { class: "size" }
const _hoisted_218 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_219 = { class: "bg-light p-2 rounded border mb-3" }
const _hoisted_220 = {
  key: 0,
  class: "row mx-n2"
}
const _hoisted_221 = {
  key: 0,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_222 = { class: "row mx-n2" }
const _hoisted_223 = { class: "col-xl-6 px-2" }
const _hoisted_224 = { class: "form-group" }
const _hoisted_225 = { for: "" }
const _hoisted_226 = { class: "text-red" }
const _hoisted_227 = { class: "col-xl-6 px-2" }
const _hoisted_228 = { class: "form-group" }
const _hoisted_229 = { for: "" }
const _hoisted_230 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_231 = { class: "text-red " }
const _hoisted_232 = { class: "col-xl-6 px-2" }
const _hoisted_233 = { class: "form-group" }
const _hoisted_234 = { for: "" }
const _hoisted_235 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_236 = { class: "text-red" }
const _hoisted_237 = { class: "col-xl-6 px-2" }
const _hoisted_238 = { class: "form-group" }
const _hoisted_239 = {
  for: "",
  class: "to-upper"
}
const _hoisted_240 = { class: "input-group" }
const _hoisted_241 = { class: "text-red" }
const _hoisted_242 = { class: "col-xl-6 px-2" }
const _hoisted_243 = { class: "form-group" }
const _hoisted_244 = { for: "" }
const _hoisted_245 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_246 = { class: "form-check form-check-inline" }
const _hoisted_247 = {
  class: "form-check-label",
  for: "inlineCheckbox1"
}
const _hoisted_248 = { class: "form-check form-check-inline" }
const _hoisted_249 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_250 = { class: "text-red" }
const _hoisted_251 = { class: "col-xl-6 px-2" }
const _hoisted_252 = { class: "form-group" }
const _hoisted_253 = { for: "" }
const _hoisted_254 = { class: "text-end" }
const _hoisted_255 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-circle" }, null, -1)
const _hoisted_256 = {
  key: 1,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_257 = { class: "text-end" }
const _hoisted_258 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt" }, null, -1)
const _hoisted_259 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_260 = { class: "row mx-n2" }
const _hoisted_261 = { class: "col-xl-6 px-2" }
const _hoisted_262 = { class: "mb-3" }
const _hoisted_263 = { class: "col-xl-6 px-2" }
const _hoisted_264 = { class: "mb-3" }
const _hoisted_265 = { class: "col-xl-6 px-2" }
const _hoisted_266 = { class: "mb-3" }
const _hoisted_267 = { class: "col-xl-6 px-2" }
const _hoisted_268 = { class: "mb-3" }
const _hoisted_269 = { class: "to-upper" }
const _hoisted_270 = { class: "col-xl-6 px-2" }
const _hoisted_271 = { class: "mb-3" }
const _hoisted_272 = { key: 0 }
const _hoisted_273 = /*#__PURE__*/_createTextVNode("       ")
const _hoisted_274 = { key: 1 }
const _hoisted_275 = { class: "col-xl-6 px-2" }
const _hoisted_276 = { class: "mb-3" }
const _hoisted_277 = {
  key: 1,
  class: "alert alert-warning text-center",
  role: "alert"
}
const _hoisted_278 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)
const _hoisted_279 = { class: "form-group" }
const _hoisted_280 = { for: "" }
const _hoisted_281 = {
  key: 8,
  class: "form-check form-check-inline mb-2"
}
const _hoisted_282 = {
  for: "Approve By All Members",
  title: "Approve By All Members"
}
const _hoisted_283 = { class: "form-group mt-3" }
const _hoisted_284 = {
  key: 0,
  for: ""
}
const _hoisted_285 = { class: "required" }
const _hoisted_286 = { class: "modal-wrap default-modal" }
const _hoisted_287 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: -1,
  "aria-labelledby": "showPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_288 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_289 = { class: "modal-content" }
const _hoisted_290 = { class: "modal-header" }
const _hoisted_291 = {
  class: "modal-title to-upper",
  id: "showPojectLabel"
}
const _hoisted_292 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_293 = { class: "modal-body" }
const _hoisted_294 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_295 = { class: "modal-footer" }
const _hoisted_296 = { class: "modal-wrap default-modal" }
const _hoisted_297 = {
  class: "modal fade",
  id: "addCompanyInfo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_298 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_299 = { class: "modal-content" }
const _hoisted_300 = { class: "modal-header" }
const _hoisted_301 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_302 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_303 = { class: "modal-body" }
const _hoisted_304 = { class: "row" }
const _hoisted_305 = { class: "col-md-12" }
const _hoisted_306 = {
  key: 0,
  class: "form-group"
}
const _hoisted_307 = { for: "" }
const _hoisted_308 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_309 = { class: "form-group" }
const _hoisted_310 = {
  for: "",
  class: "to-upper"
}
const _hoisted_311 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_312 = { class: "form-group" }
const _hoisted_313 = {
  for: "",
  class: "to-upper"
}
const _hoisted_314 = { class: "form-group" }
const _hoisted_315 = { for: "" }
const _hoisted_316 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_317 = { class: "custom-file" }
const _hoisted_318 = { class: "upload-btn-wrapper" }
const _hoisted_319 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_320 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_321 = { class: "form-group" }
const _hoisted_322 = { for: "" }
const _hoisted_323 = { class: "form-group" }
const _hoisted_324 = { for: "" }
const _hoisted_325 = { class: "modal-footer" }
const _hoisted_326 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_327 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "inviteMemberCustomValidity",
  tabindex: "-1",
  "aria-labelledby": "inviteMemberCustomValidity",
  "aria-hidden": "true"
}
const _hoisted_328 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_329 = { class: "modal-content" }
const _hoisted_330 = { class: "modal-header" }
const _hoisted_331 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  })
], -1)
const _hoisted_332 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_333 = { class: "modal-body" }
const _hoisted_334 = { class: "row" }
const _hoisted_335 = { class: "col-md-6" }
const _hoisted_336 = { class: "form-group" }
const _hoisted_337 = /*#__PURE__*/_createVNode("label", { for: "startDate" }, "Initial Date", -1)
const _hoisted_338 = { class: "col-md-6" }
const _hoisted_339 = { class: "form-group" }
const _hoisted_340 = /*#__PURE__*/_createVNode("label", { for: "startDate" }, "Final Date", -1)
const _hoisted_341 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_SendEstimationInvitationAddPhaseModal = _resolveComponent("SendEstimationInvitationAddPhaseModal")
  const _component_Editor = _resolveComponent("Editor")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_AppDeleteConfirmationModal = _resolveComponent("AppDeleteConfirmationModal")
  const _component_SignaturePadModal = _resolveComponent("SignaturePadModal")
  const _component_SignatureUploadModal = _resolveComponent("SignatureUploadModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.state.ui.isLoading.loadDetailsData ||
      _ctx.state.ui.isLoading.getSmartContractDetails
    )
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn outline d-inline-block",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectToDo && _ctx.redirectToProjectToDo(...args)))
                }, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_ErrorList, {
            errors: _ctx.state.ui.errors.errorList.approval,
            hasError: _ctx.state.ui.errors.hasError
          }, null, 8, ["errors", "hasError"]),
          (_ctx.state.data.estimation.title && _ctx.state.data.estimation)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _withDirectives(_createVNode("input", {
                      disabled: "",
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.estimation.title = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.estimation.title]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('project_name')), 1),
                _withDirectives(_createVNode("input", {
                  disabled: "",
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.projectEstimations.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.name]
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('total_project_estimation')), 1),
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.usdPriceFormate(_ctx.state.data.projectEstimations.estimatedBudget, null)), 1)
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('project_details')), 1),
                _withDirectives(_createVNode("textarea", {
                  disabled: "",
                  class: "form-control",
                  rows: "6",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.projectEstimations.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.description]
                ])
              ])
            ])
          ]),
          _hoisted_23,
          (_ctx.state.data.isActiveEdocLink)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _createVNode("p", null, _toDisplayString(_ctx.$t('or')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.data.isActiveEdocLink)
            ? (_openBlock(), _createBlock("div", _hoisted_25, [
                _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('edoc_link')), 1),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.projectEstimations.edocLink = $event)),
                  placeholder: "https://qa.convorally.com"
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.edocLink]
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_27, [
            _createVNode("button", {
              type: "submit",
              disabled: _ctx.hasValidIds,
              class: "btn default-btn d-inline-block mr-2",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showAddPhaseModal && _ctx.showAddPhaseModal(...args)))
            }, _toDisplayString(_ctx.$t('add_phase')), 9, ["disabled"])
          ]),
          (_ctx.state.data.createPhase.length > 0)
            ? (_openBlock(), _createBlock("p", _hoisted_28, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('phases')), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.createPhase, (phase, phaseIndex) => {
            return (_openBlock(), _createBlock("div", {
              class: "border p-3 rounded my-2",
              key: phaseIndex
            }, [
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _createVNode("label", _hoisted_32, _toDisplayString(phase.name), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn btn-sm text-primary mr-2",
                      title: "Edit",
                      onClick: ($event: any) => (_ctx.editNewPhase(phase, phaseIndex))
                    }, [
                      _hoisted_35,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                    ], 8, ["onClick"]),
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn btn-sm text-danger",
                      title: "delete",
                      onClick: ($event: any) => (_ctx.selectForDeletePhase(phase))
                    }, [
                      _hoisted_36,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                    ], 8, ["onClick"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _createVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createVNode("div", _hoisted_41, [
                      _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.usdPriceFormate(phase.budget, null)), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.calculatePhaseTotalDays(phase)), 1)
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_46, [
                  _createVNode("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, [
                      _hoisted_49,
                      (phase?.phaseTimeline?.type == 4)
                        ? (_openBlock(), _createBlock("p", _hoisted_50, [
                            _hoisted_51
                          ]))
                        : (phase?.phaseTimeline?.startDate && phase?.phaseTimeline?.endDate)
                          ? (_openBlock(), _createBlock("p", _hoisted_52, [
                              _createVNode("strong", null, _toDisplayString(phase.phaseTimeline.startDate) + " - " + _toDisplayString(phase.phaseTimeline.endDate), 1)
                            ]))
                          : (_openBlock(), _createBlock("p", _hoisted_53, [
                              _hoisted_54
                            ]))
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_55, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_description')) + " : ", 1)
                ]),
                _createVNode("p", null, [
                  _createVNode("small", null, _toDisplayString(phase.description), 1)
                ])
              ]),
              (phase.child_phases || phase.tasks)
                ? (_openBlock(), _createBlock("div", _hoisted_56, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.child_phases ||
              phase.groupTasks, (task, taskIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "mb-3 border-bottom pb-3",
                        key: taskIndex
                      }, [
                        _createVNode("div", _hoisted_57, [
                          _createVNode("div", _hoisted_58, [
                            _createVNode("div", _hoisted_59, [
                              _createVNode("label", _hoisted_60, _toDisplayString(task.name), 1)
                            ])
                          ]),
                          (task.allMembers)
                            ? (_openBlock(), _createBlock("div", _hoisted_61, [
                                _createVNode("div", _hoisted_62, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.allMembers, (user, userIndex) => {
                                    return (_openBlock(), _createBlock("a", {
                                      href: "javascript:void(0)",
                                      key: userIndex
                                    }, [
                                      _createVNode("span", null, [
                                        _createVNode("img", {
                                          src: user.image
                          ? user.image
                          : `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          ,
                                          alt: "user.email",
                                          title: user.email
                                        }, null, 8, ["src", "title"])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_63, [
                          (task.budget)
                            ? (_openBlock(), _createBlock("div", _hoisted_64, [
                                _createVNode("div", _hoisted_65, [
                                  _hoisted_66,
                                  _createVNode("div", _hoisted_67, [
                                    _createVNode("p", null, _toDisplayString(_ctx.$t('estimation')), 1),
                                    _createVNode("p", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.usdPriceFormate(task.budget, null)), 1)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_68, [
                          _createVNode("div", _hoisted_69, [
                            _createVNode("p", null, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('task_description')) + ":", 1)
                            ]),
                            _createVNode("p", null, [
                              _createVNode("small", null, _toDisplayString(task.description), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_70, [
                            _createVNode("div", _hoisted_71, [
                              _createVNode("div", _hoisted_72, [
                                _hoisted_73,
                                _createVNode("p", null, [
                                  _createVNode("small", null, _toDisplayString(_ctx.calculateTaskDays(task.taskTimeline)), 1)
                                ])
                              ])
                            ])
                          ]),
                          (['2', '3'].includes(task.taskTimeline.type))
                            ? (_openBlock(), _createBlock("div", _hoisted_74, [
                                _createVNode("div", _hoisted_75, [
                                  _createVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "excludeWeekends",
                                    checked: task.taskTimeline.excludeWeekends === 1,
                                    disabled: ""
                                  }, null, 8, ["checked"]),
                                  _hoisted_76
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_77, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('item_lists')) + " :", 1)
                          ]),
                          ((task.items && task.items.length > 0) ||
                  task.estimation_items
                )
                            ? (_openBlock(), _createBlock("div", _hoisted_78, [
                                _createVNode("div", _hoisted_79, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.items ||
                      task.estimation_items, (item, itemIndex) => {
                                    return (_openBlock(), _createBlock("div", {
                                      class: "card p-1",
                                      key: itemIndex
                                    }, [
                                      _createVNode("div", {
                                        class: "card-header p-0",
                                        id: `heading${itemIndex}${taskIndex}${item.id}`
                                      }, [
                                        _createVNode("h2", _hoisted_80, [
                                          _createVNode("button", {
                                            class: "btn btn-link text-left shadow-none collapsed",
                                            type: "button",
                                            "data-toggle": "collapse",
                                            "data-target": `#collapse${itemIndex}${taskIndex}${item.id}`,
                                            "aria-expanded": "true",
                                            "aria-controls": "collapseOne"
                                          }, _toDisplayString(item.name), 9, ["data-target"])
                                        ])
                                      ], 8, ["id"]),
                                      _createVNode("div", {
                                        id: `collapse${itemIndex}${taskIndex}${item.id}`,
                                        class: "collapse",
                                        "aria-labelledby": `heading${itemIndex}${taskIndex}${item.id}`,
                                        "data-parent": "#accordionExample"
                                      }, [
                                        _createVNode("div", _hoisted_81, [
                                          _createVNode("div", _hoisted_82, [
                                            _createVNode("div", _hoisted_83, [
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('item_name')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(item.name), 1),
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('item_cost')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(item.cost, null)), 1),
                                              _createVNode("p", _hoisted_84, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('quantity')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                            ]),
                                            _createVNode("div", _hoisted_85, [
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('mark_up')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(item.markup, item.markup_type)), 1),
                                              _createVNode("p", null, [
                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('item_description')), 1)
                                              ]),
                                              _createVNode("p", null, _toDisplayString(item.description), 1)
                                            ])
                                          ])
                                        ])
                                      ], 8, ["id", "aria-labelledby"])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (phase.attachments && phase.attachments.length)
                ? (_openBlock(), _createBlock("div", _hoisted_86, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_attachments')) + " : ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (phase.attachments && phase.attachments.length)
                ? (_openBlock(), _createBlock("div", _hoisted_87, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.extension === 'jpg' ||
                image.extension === 'png' ||
                image.extension === 'jpeg' ||
                image.extension === 'gif'
              )
                          ? (_openBlock(), _createBlock("div", _hoisted_88, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_89, [
                                    _createVNode("span", _hoisted_90, [
                                      _createVNode("span", _hoisted_91, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(phase, image))
                              }, [
                                _hoisted_92
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_93, [
                                _createVNode("div", _hoisted_94, [
                                  _createVNode("img", {
                                    src: image.file,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_95, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_96, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_97, [
                                    _createVNode("span", _hoisted_98, [
                                      _createVNode("span", _hoisted_99, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(image))
                              }, [
                                _hoisted_100
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_101, [
                                _createVNode("div", _hoisted_102, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                      ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                      : 'img/pdf.jpg'
                      ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_103, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'doc' || image.extension === 'docx')
                          ? (_openBlock(), _createBlock("div", _hoisted_104, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_105, [
                                    _createVNode("span", _hoisted_106, [
                                      _createVNode("span", _hoisted_107, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(image))
                              }, [
                                _hoisted_108
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_109, [
                                _hoisted_110,
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_111, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'mp4' ||
                image.extension === 'mov' ||
                image.extension === 'MOV' ||
                image.extension === 'wmv' ||
                image.extension === 'webm' ||
                image.extension === 'ogg' ||
                image.extension === 'avi' ||
                image.extension === 'x-ms-wmv'
              )
                          ? (_openBlock(), _createBlock("div", _hoisted_112, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_113, [
                                    _createVNode("div", _hoisted_114, [
                                      _createVNode("span", _hoisted_115, [
                                        _createVNode("span", _hoisted_116, _toDisplayString(_ctx.$t('loading1')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                  ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                  : 'img/video-icon.png'
                  ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.name), 1),
                              _createVNode("p", _hoisted_117, _toDisplayString(image.size), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedAttachment(image))
                              }, [
                                _hoisted_118
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.state.data.createPhase.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_119, [
                _createVNode("div", _hoisted_120, [
                  _createVNode("div", _hoisted_121, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, " No. of days for this project: " + _toDisplayString(_ctx.calculateProjectTotalDays), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_122, [
                  _createVNode("div", _hoisted_123, [
                    _hoisted_124,
                    _withDirectives(_createVNode("select", {
                      id: "projectDate",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.projectDate.type = $event)),
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleDateTypeChange && _ctx.handleDateTypeChange(...args)))
                    }, [
                      _hoisted_125,
                      _createVNode("option", _hoisted_126, _toDisplayString(_ctx.state.projectDate.startDate && _ctx.state.projectDate.endDate ?
                  `${_ctx.state.projectDate.startDate} -
                  ${_ctx.state.projectDate.endDate}` : 'Custom Date'), 1)
                    ], 512), [
                      [_vModelSelect, _ctx.state.projectDate.type]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!(_ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo))
            ? (_openBlock(), _createBlock("div", _hoisted_127, [
                _createVNode("a", {
                  "data-toggle": "modal",
                  class: "btn default-btn d-inline-block mr-2",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showCreateCompanyModel && _ctx.showCreateCompanyModel(...args)))
                }, _toDisplayString(_ctx.$t('add_company_information')), 1)
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.data.companyInfo.acknowledgement &&
          _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.estimation.acknowledgement &&
            _ctx.state.data.estimation.legal_statement)
        )
            ? (_openBlock(), _createBlock("p", _hoisted_128, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('company_contract_preview')), 1)
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.data.companyInfo.acknowledgement &&
          _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.estimation.acknowledgement &&
            _ctx.state.data.estimation.legal_statement)
        )
            ? (_openBlock(), _createBlock("div", _hoisted_129, [
                _createVNode("p", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')), 1),
                  _createVNode("a", {
                    class: "btn default-btn btn-sm ms-2",
                    title: "Edit",
                    href: "javascript:void(0)",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.editCompany && _ctx.editCompany(...args)))
                  }, [
                    _hoisted_130,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                  ])
                ]),
                (_ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo)
                  ? (_openBlock(), _createBlock("div", _hoisted_131, [
                      ((_ctx.state.data.companyInfo.logo && _ctx.state.data.companyInfo.logo.file) || (_ctx.state.data.estimation.logo && _ctx.state.data.estimation.logo.file)
            )
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            class: "rounded",
                            src: (_ctx.state.data.companyInfo.logo.file || _ctx.state.data.estimation.logo.file)
              ? (_ctx.state.data.companyInfo.logo.file || _ctx.state.data.estimation.logo.file)
              : (_ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo)
              ,
                            alt: ""
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock("img", {
                            key: 1,
                            class: "rounded",
                            src: _ctx.state.data.companyInfo.logo || _ctx.state.data.estimation.logo,
                            alt: ""
                          }, null, 8, ["src"]))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_132, [
                  _createVNode("ul", _hoisted_133, [
                    _createVNode("li", _hoisted_134, [
                      _createVNode("button", _hoisted_135, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                    ]),
                    _createVNode("li", _hoisted_136, [
                      _createVNode("button", _hoisted_137, _toDisplayString(_ctx.$t('legal_statement')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_138, [
                    _createVNode("div", _hoisted_139, [
                      _createVNode("div", {
                        innerHTML: _ctx.state.data.estimation?.acknowledgement || _ctx.state.data.companyInfo.acknowledgement
                      }, null, 8, ["innerHTML"])
                    ]),
                    _createVNode("div", _hoisted_140, [
                      _createVNode("div", {
                        innerHTML: _ctx.state.data.estimation?.legal_statement || _ctx.state.data.companyInfo.legal_statement
                      }, null, 8, ["innerHTML"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_141, [
            _createVNode("ul", null, [
              (!_ctx.state.ui.isLoading.signaturePadLoad && _ctx.state.data.sendarSignature)
                ? (_openBlock(), _createBlock("li", _hoisted_142, [
                    _createVNode("label", _hoisted_143, [
                      _createTextVNode(_toDisplayString(_ctx.$t('signature')) + " ", 1),
                      _hoisted_144
                    ]),
                    (_ctx.state.data.sendarSignature)
                      ? (_openBlock(), _createBlock("div", _hoisted_145, [
                          _createVNode("img", {
                            src: _ctx.state.data.sendarSignature,
                            alt: ""
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("button", {
                      for: "formFileSm",
                      class: "btn default-btn mr-2",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.enableSignaturPad && _ctx.enableSignaturPad(...args)))
                    }, _toDisplayString(_ctx.$t('add_new_signature')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("li", {
                class: !_ctx.state.ui.isLoading.signaturePadLoad && _ctx.state.data.sendarSignature ? 'd-none' : ''
              }, [
                _createVNode("div", _hoisted_146, [
                  _createVNode("div", null, [
                    (_ctx.state.data.cropSignature)
                      ? (_openBlock(), _createBlock("div", _hoisted_147, [
                          _createVNode("img", {
                            src: _ctx.state.data.cropSignature,
                            alt: ""
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_148, [
                  _createVNode("div", _hoisted_149, [
                    _createVNode("ul", null, [
                      _createVNode("li", null, [
                        _createVNode("div", _hoisted_150, [
                          _createVNode("button", _hoisted_151, [
                            _hoisted_152,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_signature')), 1)
                          ]),
                          _createVNode("input", {
                            ref: "signatureInput",
                            type: "file",
                            accept: "image/png, image/jpeg",
                            id: "profileUpdate",
                            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.uploadSignatureFile($event)))
                          }, null, 544)
                        ])
                      ]),
                      _createVNode("li", null, [
                        _createVNode("button", {
                          class: "btn default-btn",
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showSignaturePad && _ctx.showSignaturePad(...args)))
                        }, [
                          _hoisted_153,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('draw_signature')), 1)
                        ])
                      ]),
                      (_ctx.state.data.haveProfileSign)
                        ? (_openBlock(), _createBlock("li", _hoisted_154, [
                            _createVNode("div", _hoisted_155, [
                              _createVNode("button", {
                                for: "formFileSm",
                                class: "btn default-btn mr-2",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.userSignature('use')))
                              }, [
                                _hoisted_156,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('use_profile_signature')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("li", null, [
                        _createVNode("button", {
                          class: "btn red-btn",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.clearSignature()))
                        }, _toDisplayString(_ctx.$t('clear')), 1)
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ]),
          _createVNode("div", _hoisted_157, [
            _createVNode("label", _hoisted_158, _toDisplayString(_ctx.$t('attachments_docs')), 1),
            (_ctx.state.data.projectEstimations.attachments &&
            _ctx.state.data.projectEstimations.attachments.length
          )
              ? (_openBlock(), _createBlock("div", _hoisted_159, [
                  _createVNode("div", _hoisted_160, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectEstimations
                .attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.file_type === 'jpg' ||
                  image.file_type === 'png' ||
                  image.file_type === 'jpeg' ||
                  image.file_type === 'gif'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_161, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_162, [
                                    _createVNode("span", _hoisted_163, [
                                      _createVNode("span", _hoisted_164, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_165
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_166, [
                                _createVNode("div", _hoisted_167, [
                                  _createVNode("img", {
                                    src: image.file_link,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_168, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_169, [
                                    _createVNode("span", _hoisted_170, [
                                      _createVNode("span", _hoisted_171, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_172
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_173, [
                                _createVNode("div", _hoisted_174, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                        : 'img/pdf.jpg'
                        ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'doc' || image.file_type === 'docx')
                          ? (_openBlock(), _createBlock("div", _hoisted_175, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_176, [
                                    _createVNode("span", _hoisted_177, [
                                      _createVNode("span", _hoisted_178, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_179
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_180, [
                                _hoisted_181,
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'mp4' ||
                  image.file_type === 'mov' ||
                  image.file_type === 'MOV' ||
                  image.file_type === 'wmv' ||
                  image.file_type === 'webm' ||
                  image.file_type === 'ogg' ||
                  image.file_type === 'avi' ||
                  image.file_type === 'x-ms-wmv'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_182, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_183, [
                                    _createVNode("div", _hoisted_184, [
                                      _createVNode("span", _hoisted_185, [
                                        _createVNode("span", _hoisted_186, _toDisplayString(_ctx.$t('loading1')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                    : 'img/video-icon.png'
                    ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.file_name), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_187
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectEstimations
                .attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.extension === 'jpg' ||
                  image.extension === 'png' ||
                  image.extension === 'jpeg' ||
                  image.extension === 'gif'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_188, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_189, [
                                    _createVNode("span", _hoisted_190, [
                                      _createVNode("span", _hoisted_191, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_192
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_193, [
                                _createVNode("div", _hoisted_194, [
                                  _createVNode("img", {
                                    src: image.file,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_195, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_196, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_197, [
                                    _createVNode("span", _hoisted_198, [
                                      _createVNode("span", _hoisted_199, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_200
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_201, [
                                _createVNode("div", _hoisted_202, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                        : 'img/pdf.jpg'
                        ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_203, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'doc' || image.extension === 'docx')
                          ? (_openBlock(), _createBlock("div", _hoisted_204, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_205, [
                                    _createVNode("span", _hoisted_206, [
                                      _createVNode("span", _hoisted_207, _toDisplayString(_ctx.$t('loading1')), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_208
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_209, [
                                _hoisted_210,
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_211, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'mp4' ||
                  image.extension === 'mov' ||
                  image.extension === 'MOV' ||
                  image.extension === 'wmv' ||
                  image.extension === 'webm' ||
                  image.extension === 'ogg' ||
                  image.extension === 'avi' ||
                  image.extension === 'x-ms-wmv'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_212, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_213, [
                                    _createVNode("div", _hoisted_214, [
                                      _createVNode("span", _hoisted_215, [
                                        _createVNode("span", _hoisted_216, _toDisplayString(_ctx.$t('loading1')), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                    : 'img/video-icon.png'
                    ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.name), 1),
                              _createVNode("p", _hoisted_217, _toDisplayString(image.size), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_218
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_DragAndDropZone, {
              onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
              onDropFiles: _ctx.dropFiles
            }, null, 8, ["onDrop", "onDropFiles"])
          ]),
          _createVNode("div", _hoisted_219, [
            (_ctx.state.data.selectedCustomers.length)
              ? (_openBlock(), _createBlock("div", _hoisted_220, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedCustomers, (customer, customerIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-md-4 col-sm-6 mb-2 px-2",
                      key: customerIndex
                    }, [
                      (customer.isEdit)
                        ? (_openBlock(), _createBlock("div", _hoisted_221, [
                            _createVNode("div", _hoisted_222, [
                              _createVNode("div", _hoisted_223, [
                                _createVNode("div", _hoisted_224, [
                                  _createVNode("label", _hoisted_225, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    disabled: customer.isMailFromApi,
                                    placeholder: "Enter email address",
                                    class: customer.emailError
                        ? 'form-control error-field'
                        : 'form-control'
                        ,
                                    "onUpdate:modelValue": ($event: any) => (customer.email = $event)
                                  }, null, 10, ["disabled", "onUpdate:modelValue"]), [
                                    [_vModelText, customer.email]
                                  ]),
                                  _createVNode("p", _hoisted_226, _toDisplayString(customer.emailError), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_227, [
                                _createVNode("div", _hoisted_228, [
                                  _createVNode("label", _hoisted_229, [
                                    _createVNode("small", null, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('first_name')) + " ", 1),
                                      _hoisted_230
                                    ])
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.first_name = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.first_name]
                                  ]),
                                  _createVNode("p", _hoisted_231, _toDisplayString(customer.firstNameError), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_232, [
                                _createVNode("div", _hoisted_233, [
                                  _createVNode("label", _hoisted_234, [
                                    _createVNode("small", null, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('last_name')) + " ", 1),
                                      _hoisted_235
                                    ])
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.last_name = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.last_name]
                                  ]),
                                  _createVNode("p", _hoisted_236, _toDisplayString(customer.lastNameError), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_237, [
                                _createVNode("div", _hoisted_238, [
                                  _createVNode("label", _hoisted_239, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_240, [
                                    _withDirectives(_createVNode("input", {
                                      disabled: !!customer.isPhoneFromApi,
                                      type: "number",
                                      class: customer.phoneError ? 'form-control error-field' : 'form-control',
                                      placeholder: _ctx.$t('mobile_number_only'),
                                      "onUpdate:modelValue": ($event: any) => (customer.phone = $event)
                                    }, null, 10, ["disabled", "placeholder", "onUpdate:modelValue"]), [
                                      [_vModelText, customer.phone]
                                    ]),
                                    _createVNode("p", _hoisted_241, _toDisplayString(customer.phoneError), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_242, [
                                _createVNode("div", _hoisted_243, [
                                  _createVNode("label", _hoisted_244, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_245, [
                                    _createVNode("div", _hoisted_246, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "inlineCheckbox1",
                                        value: "true",
                                        disabled: customer.isMailFromApi,
                                        "onUpdate:modelValue": ($event: any) => (customer.mailNotification = $event)
                                      }, null, 8, ["disabled", "onUpdate:modelValue"]), [
                                        [_vModelCheckbox, customer.mailNotification]
                                      ]),
                                      _createVNode("label", _hoisted_247, _toDisplayString(_ctx.$t('email')), 1)
                                    ]),
                                    _createVNode("div", _hoisted_248, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "inlineCheckbox2",
                                        value: "true",
                                        "onUpdate:modelValue": ($event: any) => (customer.smsNotification = $event),
                                        disabled: customer.isPhoneFromApi
                                      }, null, 8, ["onUpdate:modelValue", "disabled"]), [
                                        [_vModelCheckbox, customer.smsNotification]
                                      ]),
                                      _createVNode("label", _hoisted_249, _toDisplayString(_ctx.$t('sms')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", _hoisted_250, _toDisplayString(customer.mailNotificationError), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_251, [
                                _createVNode("div", _hoisted_252, [
                                  _createVNode("label", _hoisted_253, [
                                    _createVNode("small", null, _toDisplayString(_ctx.$t('address')), 1)
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.address_line1 = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.address_line1]
                                  ])
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_254, [
                              _createVNode("a", {
                                class: "btn default-btn btn-sm to-upper",
                                title: "Update",
                                href: "javascript:void(\n                            0)",
                                onClick: ($event: any) => (_ctx.updateSelectCustomer(customerIndex))
                              }, [
                                _hoisted_255,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('update')), 1)
                              ], 8, ["onClick"])
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_256, [
                            _createVNode("div", _hoisted_257, [
                              _createVNode("a", {
                                class: "btn default-btn btn-sm mr-2",
                                title: "Edit",
                                href: "javascript:void(\n                            0)",
                                onClick: ($event: any) => (_ctx.editSelectCustomer(customerIndex))
                              }, [
                                _hoisted_258,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                              ], 8, ["onClick"]),
                              _createVNode("a", {
                                class: "btn btn-sm red-btn",
                                title: "Delete",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.showDelete(customer))
                              }, [
                                _hoisted_259,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("div", _hoisted_260, [
                              _createVNode("div", _hoisted_261, [
                                _createVNode("div", _hoisted_262, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.email), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_263, [
                                _createVNode("div", _hoisted_264, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('first_name')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.first_name), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_265, [
                                _createVNode("div", _hoisted_266, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('last_name')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.last_name), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_267, [
                                _createVNode("div", _hoisted_268, [
                                  _createVNode("p", _hoisted_269, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.phone), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_270, [
                                _createVNode("div", _hoisted_271, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    (customer.mailNotification)
                                      ? (_openBlock(), _createBlock("small", _hoisted_272, _toDisplayString(_ctx.$t('mail')), 1))
                                      : _createCommentVNode("", true),
                                    _hoisted_273,
                                    (customer.smsNotification)
                                      ? (_openBlock(), _createBlock("small", _hoisted_274, _toDisplayString(_ctx.$t('sms')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_275, [
                                _createVNode("div", _hoisted_276, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('address')), 1)
                                    ])
                                  ]),
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.address_line1), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_277, [
                  _hoisted_278,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('customer_does_not_selected')) + " " + _toDisplayString(_ctx.$t('please_select_or_add_customer_email')), 1)
                ]))
          ]),
          _createVNode("div", _hoisted_279, [
            _createVNode("label", _hoisted_280, _toDisplayString(_ctx.$t('customer_emails')), 1),
            _createVNode(_component_multiselect, {
              modelValue: _ctx.state.data.selectedCustomers,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.data.selectedCustomers = $event)),
              "tag-placeholder": "Select or add customer email",
              placeholder: _ctx.$t('select_or_add_customer_email'),
              label: "code",
              "track-by": "code",
              options: _ctx.filterUsersWithEmail(_ctx.state.data.allCustomer),
              multiple: true,
              taggable: true,
              onTag: _ctx.addCustomerEmail,
              onSelect: _ctx.changeValue
            }, null, 8, ["modelValue", "placeholder", "options", "onTag", "onSelect"]),
            _withDirectives(_createVNode("p", { class: "text-red" }, _toDisplayString(_ctx.$t('please_add_valid_email_only')), 513), [
              [_vShow, _ctx.isInvalid]
            ])
          ]),
          (_ctx.state.data.selectedCustomers.length >= 2)
            ? (_openBlock(), _createBlock("div", _hoisted_281, [
                _withDirectives(_createVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.data.approveByAll = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.state.data.approveByAll]
                ]),
                _createVNode("label", _hoisted_282, _toDisplayString(_ctx.$t('approve_by_all_members')), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_283, [
            _createVNode("button", {
              type: "submit",
              class: "btn default-btn d-inline-block mr-2 outline",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sendInvitationEstimation(0))),
              disabled: _ctx.state.ui.isPostLoading.saveEstimation
            }, _toDisplayString(_ctx.state.ui.isPostLoading.saveEstimation ? _ctx.$t('saving') : _ctx.$t('save_as_draft')), 9, ["disabled"]),
            _createVNode("button", {
              type: "submit",
              class: "btn default-btn d-inline-block mr-2",
              disabled: _ctx.iActiveValidation,
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sendInvitationEstimation(1)))
            }, _toDisplayString(_ctx.state.ui.isPostLoading.sendEstimation ? _ctx.$t('loading1') : _ctx.$t('send')), 9, ["disabled"]),
            _createVNode("button", {
              type: "submit",
              class: "btn red-btn d-inline-block to-upper",
              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectToDo && _ctx.redirectToProjectToDo(...args)))
            }, _toDisplayString(_ctx.$t('cancel')), 1),
            (_ctx.state.ui.isLoading.isReadyToSend)
              ? (_openBlock(), _createBlock("label", _hoisted_284, [
                  _createVNode("span", _hoisted_285, _toDisplayString(_ctx.$t('some_phase_items_not_selected')) + " " + _toDisplayString(_ctx.$t('please_verify')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.state.data.showSuccesCustomModal)
          ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
              key: 0,
              onClose: _ctx.closeSuccessCustomModal,
              showModal: _ctx.state.data.showSuccesCustomModal,
              titleMessage: _ctx.state.data.successFulMessage
            }, null, 8, ["onClose", "showModal", "titleMessage"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_286, [
          _createVNode("div", _hoisted_287, [
            _createVNode("div", _hoisted_288, [
              _createVNode("div", _hoisted_289, [
                _createVNode("div", _hoisted_290, [
                  _createVNode("h5", _hoisted_291, _toDisplayString(_ctx.$t('remove')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_292
                  ])
                ]),
                _createVNode("div", _hoisted_293, [
                  _createVNode("div", _hoisted_294, _toDisplayString(_ctx.$t('are_you_sure_you_want_to_remove')), 1)
                ]),
                _createVNode("div", _hoisted_295, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.removeSelectCustomer(_ctx.state.data.removeUser)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.delete ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    "data-dismiss": "modal",
                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args)))
                  }, _toDisplayString(_ctx.$t('no')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showAddPhaseModal)
        ? (_openBlock(), _createBlock(_component_SendEstimationInvitationAddPhaseModal, {
            key: 1,
            showAddPhase: _ctx.state.data.showAddPhaseModal,
            editMode: _ctx.state.data.editMode,
            editData: _ctx.state.data.editData,
            projectAcknowledgementDetail: _ctx.state.data.projectEstimations,
            editFrom: _ctx.state.data.editFrom,
            checkData: _ctx.state.data.selectedItemList,
            phases: _ctx.state.data.sendPhases,
            onClose: _ctx.closeAddPhaseModal,
            onReset: _ctx.resetAddPhaseModal,
            onAddPhase: _ctx.addNewPhase,
            onUpdatePhase: _ctx.updatePhase,
            onResetChecked: _ctx.resetChecked,
            onUpdateTask: _ctx.updateTask
          }, null, 8, ["showAddPhase", "editMode", "editData", "projectAcknowledgementDetail", "editFrom", "checkData", "phases", "onClose", "onReset", "onAddPhase", "onUpdatePhase", "onResetChecked", "onUpdateTask"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_296, [
        _createVNode("div", _hoisted_297, [
          _createVNode("div", _hoisted_298, [
            _createVNode("div", _hoisted_299, [
              _createVNode("div", _hoisted_300, [
                _createVNode("h5", _hoisted_301, _toDisplayString(_ctx.$t('add_company_information')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, [
                  _hoisted_302
                ])
              ]),
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.createCompanyIfno,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_303, [
                _createVNode("div", _hoisted_304, [
                  _createVNode("div", _hoisted_305, [
                    (!_ctx.state.ui.isLoading.isCompanyEdit)
                      ? (_openBlock(), _createBlock("div", _hoisted_306, [
                          _createVNode("label", _hoisted_307, _toDisplayString(_ctx.$t('company_name')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.state.data.companyInfo.company_name = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_name]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_308, [
                        _createVNode("div", _hoisted_309, [
                          _createVNode("label", _hoisted_310, _toDisplayString(_ctx.$t('phone_number')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.state.data.companyInfo.company_phone_number = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_phone_number]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_311, [
                        _createVNode("div", _hoisted_312, [
                          _createVNode("label", _hoisted_313, _toDisplayString(_ctx.$t('email_address')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.state.data.companyInfo.company_email = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_email]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_314, [
                  _createVNode("label", _hoisted_315, _toDisplayString(_ctx.$t('company_logo')), 1),
                  (_ctx.state.data.estimation.logo)
                    ? (_openBlock(), _createBlock("div", _hoisted_316, [
                        _createVNode("img", {
                          src: _ctx.state.data.estimation.logo.file
                    ? _ctx.state.data.estimation.logo.file
                    : _ctx.state.data.estimation.logo
                    ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_317, [
                    _createVNode("div", _hoisted_318, [
                      _createVNode("button", _hoisted_319, [
                        _hoisted_320,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')), 1)
                      ]),
                      _createVNode("input", {
                        type: "file",
                        accept: "image/png, image/jpeg",
                        id: "profileUpdate",
                        onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.uploadLogo($event)))
                      }, null, 32)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_321, [
                  _createVNode("label", _hoisted_322, _toDisplayString(_ctx.$t('add_acknowledgement')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.acknowledgement,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.acknowledgement = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_323, [
                  _createVNode("label", _hoisted_324, _toDisplayString(_ctx.$t('add_conduct_of_contract')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.legalStatement,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.legalStatement = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_325, [
                (_ctx.state.ui.isLoading.isCompanyEdit)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                    }, _toDisplayString(_ctx.$t('update')), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.createCompanyIfno && _ctx.createCompanyIfno(...args)))
                    }, _toDisplayString(_ctx.$t('save_changes')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_326, [
        _createVNode("div", _hoisted_327, [
          _createVNode("div", _hoisted_328, [
            _createVNode("div", _hoisted_329, [
              _createVNode("div", _hoisted_330, [
                _hoisted_331,
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.hideCustomValidity && _ctx.hideCustomValidity(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_332
                ])
              ]),
              _createVNode("div", _hoisted_333, [
                _createVNode("div", _hoisted_334, [
                  _createVNode("div", _hoisted_335, [
                    _createVNode("div", _hoisted_336, [
                      _hoisted_337,
                      _createVNode(_component_v_date_picker, {
                        id: "startDate",
                        modelValue: _ctx.customStartDate,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.customStartDate = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_338, [
                    _createVNode("div", _hoisted_339, [
                      _hoisted_340,
                      _createVNode(_component_v_date_picker, {
                        id: "endDate",
                        modelValue: _ctx.customEndDate,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.customEndDate = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_341, [
                _createVNode("div", null, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.saveCustomDaysToselectedMember && _ctx.saveCustomDaysToselectedMember(...args)))
                  }, _toDisplayString(_ctx.$t('save')), 1),
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn secondary-btn mr-2",
                    onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.hideCustomValidity && _ctx.hideCustomValidity(...args)))
                  }, _toDisplayString(_ctx.$t('cancel')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showDeletePhaseConfirmation)
        ? (_openBlock(), _createBlock(_component_AppDeleteConfirmationModal, {
            key: 2,
            showConfirmationModal: _ctx.state.data.showDeletePhaseConfirmation,
            onButtonTrigger: _ctx.removeSelectedPhase,
            onHideConfirmation: _ctx.hideConfirmation,
            message: _ctx.state.data.deleteModalMessage
          }, null, 8, ["showConfirmationModal", "onButtonTrigger", "onHideConfirmation", "message"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.data.showSignaturePad)
      ? (_openBlock(), _createBlock(_component_SignaturePadModal, {
          key: 0,
          onClose: _ctx.hideSignaturePad,
          onUploadSignature: _ctx.uploadSignature,
          showModal: _ctx.state.data.showSignaturePad,
          from: 'estimation'
        }, null, 8, ["onClose", "onUploadSignature", "showModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignatureUpload)
      ? (_openBlock(), _createBlock(_component_SignatureUploadModal, {
          key: 1,
          showModal: _ctx.state.data.showSignatureUpload,
          signatureFile: _ctx.state.data.uploadSignatureFile,
          from: 'estimation',
          onClose: _ctx.hideSignatureUpload,
          onUploadSignature: _ctx.uploadSignature
        }, null, 8, ["showModal", "signatureFile", "onClose", "onUploadSignature"]))
      : _createCommentVNode("", true)
  ], 64))
}